/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
import { cloneDeep, replace, sum } from "lodash";
import React, { useState } from "react";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import config from "../../config/config";
import InputTable from "../../common/InputTable";
import numberFormat from "../../common/numberFormat";
import LabelText from "../../common/LabelText";
import DetailBlock from "../../common/DetailBlock";
import AppButton from "../../common/AppButton";
import removeCommas from "../../common/removeCommas";
import { serializeTable } from "../../common/serialize";
import addPrecision from "../../common/addPrecision";
import api from "../../config/api";
import focusInputByName from "../../common/focusInputByName";
import { IoLocationSharp } from "react-icons/io5";
import { AiFillCalendar } from "react-icons/ai";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import AppInput from "../../common/AppInput";
import colors from "../../config/colors";
import unSerializeTable from "../../common/unSerializeTable";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLocations } from "../../stores/LocationStore";
import { getOrganizationByid } from "../../stores/OrganizationStore";

const headers = [
  {
    label: "Service Description",
    name: "serviceDescription",
    style: { width: 500, backgroundColor: "#77777720" },
  },
  { label: "Hours", name: "hourse", style: { backgroundColor: "#77777720" } },
  { label: "Rate ($)", name: "rate", style: { backgroundColor: "#77777720" } },
  {
    label: "Amount",
    name: "amount",
    style: {
      width: 200,
      padding: "10px",
      backgroundColor: "#77777720",
    },
  },
];

const datamodel = [
  [
    {
      placeholder: "",
      name: "serviceDescription",
      value: "",
      multiline: true,
    },
    {
      placeholder: "",
      name: "hours",
      value: "",
      numberFormat: true,
    },
    {
      placeholder: "",
      name: "rate",
      value: "",
      numberFormat: true,
    },
    {
      placeholder: "",
      name: "amount",
      value: "",
      numberFormat: true,
    },
  ],
];

function JobEdit() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { data: init } = location?.state;
  const queryClient = useQueryClient();

  const { data: locations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(init.organization),
    queryKey: ["organizations", init.organization],
  });

  const [form, setForm] = useState(
    cloneDeep({
      ...init,
      jobIssueDate: new Date(init.jobIssueDate),
      location: [...init.location],
      organization: init.organization.name,
      poRequestLocation: init.organization.billingAddress,
    })
  );

  const tblData = unSerializeTable(datamodel[0], form.detailsTable);
  const [data, setData] = useState(tblData);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const found = ["tax", "jobEndDate", "jobStartDate"].filter((i) => {
      if (!form[i]) {
        focusInputByName(i);
        return i;
      }
      return false;
    });
    if (found.length > 0) {
      return false;
    }

    const detailsTable = serializeTable(data, "name", "value");

    const res = await api.put("jobs", {
      ...form,
      location: form.location,
      organizationName: init.name,
      detailsTable: detailsTable.filter((i) => i.serviceDescription),
      total: numberFormat(total),
      subtotal: numberFormat(subtotal),
      organization: params.organization_id,
      taxPercentage: tax,
    });
    if (!res.ok) return toast.error(res.originalError.message);
    toast.success("Job has been successfully updated.");
    queryClient.invalidateQueries(["jobs"]);

    navigate(
      `/organizations/view/${params.organization_id}/jobs/${res.data._id}`,
      {
        state: { data: res.data },
        replace: true,
      }
    );
  };

  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;
    if (name === "jobStartDate") {
      if (new Date(form.jobEndDate).valueOf() < new Date(value).valueOf()) {
        delete form.jobEndDate;
      }
    }
    setForm({ ...form, [name]: value });
  };

  const handleSelect = ({ target }) => {
    const name = target.name;
    const value = target.value;
    setForm({
      ...form,
      [name]: value,
      attention: `${value[0]?.incharge}\n${value[0]?.tag}`,
    });
  };
  const handleInputChange = ({
    event,
    value,
    row,
    column,
    numberFormat: num,
    noDigits,
  }) => {
    event.preventDefault();
    let vl = value;
    if (num) {
      vl = numberFormat(value);
    }
    if (noDigits) {
      vl = vl.replace(".", "");
    }
    const dt = [...data];

    if (column === 1 || column === 2) {
      const hours = +dt[row][1].value;
      const rate = +dt[row][2].value;
      const amount = hours * rate;
      dt[row][3].value = amount;
    }

    dt[row][column].value = vl;
    setData(dt);
  };
  const handleAddNewRow = () => {
    const dt = cloneDeep(datamodel);
    setData([...data, ...dt]);
  };

  const {
    jobId,
    jobIssueDate,
    jobStartDate,
    jobEndDate,
    tax,
    attention,
    helpText,
    location: loc,
    noPo,
  } = form;

  const tableData = serializeTable(data, "name", "value");
  const subtotal = sum(tableData.map((i) => Number(removeCommas(i.amount))));
  const taxValue = +Math.fround(subtotal * (1 + 0.01 * tax)).toFixed(3);
  const total = taxValue;
  const size = config.iconSize;
  const handleDelete = async () => {
    if (window.confirm("Are you sure want to delete the job ?") === false)
      return false;

    const res = await api.put("jobs", { _id: form._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["jobs"]);

    toast.success("Job has been successfully deleted");
    const { pathname } = location;
    const goto = String(pathname).replace(`jobs/${form._id}/edit`, "");
    navigate(goto, { state: { data: location.state }, replace: true });
  };
  return (
    <Body title="Edit Job">
      <form onSubmit={handleSubmit} noValidate={false}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <DetailBlock
              style={{
                boxShadow: "none",
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  marginBottom: 30,
                }}
              >
                <LabelText columnMode label="Job ID" value={jobId} />
                <LabelText
                  columnMode
                  label="Client"
                  value={organization?.name}
                />
                <LabelText
                  columnMode
                  label="PO Request Location"
                  value={init.poRequestLocation}
                />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div className="d-flex justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    width: 800,
                    flexWrap: "wrap",
                    gap: "0px 40px",
                    justifyContent: "center",
                    marginBottom: 30,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      type="date"
                      label="Issue Date"
                      onChange={handleChange}
                      name="jobIssueDate"
                      placeholder="Job Issue Date"
                      value={jobIssueDate}
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                      floatLabel
                      required
                    />
                    <AppInput
                      onChange={handleChange}
                      name="jobStartDate"
                      label="Job Start Date"
                      placeholder="Job Start Date"
                      datePicker
                      floatLabel
                      value={new Date(jobStartDate)}
                      required
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                    <AppInput
                      onChange={handleChange}
                      name="jobEndDate"
                      label="Job End Date"
                      placeholder="Job End Date"
                      datePicker
                      minDate={new Date(jobStartDate)}
                      value={new Date(jobEndDate)}
                      required
                      floatLabel
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                  </div>
                  {init.location && (
                    <AppInput
                      type="multi"
                      chip
                      label="Job Location"
                      name="location"
                      onChange={handleSelect}
                      leftIcon={
                        <IoLocationSharp size={size} color={"silver"} />
                      }
                      style={{ width: 800 }}
                      options={organization?.locations?.map((i) => {
                        const found = locations?.find((item) => item._id === i);

                        return {
                          ...found,
                          name: `${found.tag} - ${found.title}`,
                        };
                      })}
                      filterBy="name"
                      value={loc.map((i) => {
                        const found = locations?.find(
                          (item) => item._id === i._id || item._id === i
                        );

                        return {
                          ...found,
                          name: `${found.tag} - ${found.title}`,
                        };
                      })}
                      required
                      floatLabel
                    />
                  )}

                  <div
                    // className="d-flex"
                    style={{ width: "100%" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={noPo}
                          onChange={(_, value) => {
                            setForm({ ...form, noPo: value });
                          }}
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label="No PO"
                    />
                  </div>
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <br />
              <div
                className="d-flex"
                style={{
                  alignItems: "flex-end",
                  flexDirection: "column",
                  marginTop: 20,
                }}
              >
                <InputTable
                  className="table-bordered"
                  headers={headers}
                  list={data}
                  onInputChange={handleInputChange}
                  addNewRow={handleAddNewRow}
                />
                <div
                  style={{
                    display: "flex",
                    width: 300,
                    gap: 10,
                    flexDirection: "column",
                  }}
                >
                  <LabelText
                    label="Subtotal"
                    value={`$ ${addPrecision(numberFormat(subtotal))}`}
                    name="subtotal"
                  />
                  <LabelInput
                    onChange={handleChange}
                    style={{
                      width: 140,
                      backgroundColor: "transparent",
                    }}
                    forceLabel="HST ( % )"
                    rowMode
                    name="tax"
                    required
                    value={tax && numberFormat(tax)}
                  />
                  <LabelText
                    label="Total"
                    value={`$ ${addPrecision(numberFormat(total))}`}
                  />
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div>
                <br />
                <LabelInput
                  forceLabel={<b>Attention</b>}
                  multiline
                  name="attention"
                  style={{ maxWidth: "100%" }}
                  value={attention}
                  onChange={handleChange}
                />
                <LabelInput
                  onChange={handleChange}
                  forceLabel={<b>Body Text</b>}
                  multiline
                  name="helpText"
                  style={{ maxWidth: "100%", minHeight: 100 }}
                  value={helpText}
                />
              </div>
            </DetailBlock>
          </div>
          <div className="d-flex" style={{ margin: "20px 0px", gap: 10 }}>
            <AppButton
              type="button"
              onClick={handleSubmit}
              text="Save"
              className="btn-primary"
            />

            <AppButton
              type="button"
              onClick={handleDelete}
              text="Delete"
              className="btn-danger"
            />
          </div>
        </div>
      </form>
    </Body>
  );
}
export default observer(JobEdit);
